import { createApiMutation } from "../../generated-factory";
import { apiClientManager } from "@app/stores/api-manager";
import type { UseBatchAssignManagerRequest, UseBatchAssignManagerData, UseBatchChangeStatusRequest, UseBatchChangeStatusData, UseToggleActivityTypeRequest, UseToggleActivityTypeData, UseUpdateActivityRequest, UseUpdateActivityData, UseUpdateActivityTypeRequest, UseUpdateActivityTypeData, UseUpdateGroupRequest, UseUpdateGroupData, UseUpdateGroupMemberPetRequest, UseUpdateGroupMemberPetData, UseUpdateGroupMemberUserRequest, UseUpdateGroupMemberUserData, UseUpdateGroupScheduleRequest, UseUpdateGroupScheduleData } from "@api/@types/group";

export const useBatchAssignManager = createApiMutation<UseBatchAssignManagerData, UseBatchAssignManagerRequest>({
  mutationFn: (req) => apiClientManager.apis.group.batchAssignManager(req as UseBatchAssignManagerRequest),
});

export const useBatchChangeStatus = createApiMutation<UseBatchChangeStatusData, UseBatchChangeStatusRequest>({
  mutationFn: (req) => apiClientManager.apis.group.batchChangeStatus(req as UseBatchChangeStatusRequest),
});

export const useToggleActivityType = createApiMutation<UseToggleActivityTypeData, UseToggleActivityTypeRequest>({
  mutationFn: (req) => apiClientManager.apis.group.toggleActivityType(req as UseToggleActivityTypeRequest),
});

export const useUpdateActivity = createApiMutation<UseUpdateActivityData, UseUpdateActivityRequest>({
  mutationFn: (req) => apiClientManager.apis.group.updateActivity(req as UseUpdateActivityRequest),
});

export const useUpdateActivityType = createApiMutation<UseUpdateActivityTypeData, UseUpdateActivityTypeRequest>({
  mutationFn: (req) => apiClientManager.apis.group.updateActivityType(req as UseUpdateActivityTypeRequest),
});

export const useUpdateGroup = createApiMutation<UseUpdateGroupData, UseUpdateGroupRequest>({
  mutationFn: (req) => apiClientManager.apis.group.updateGroup(req as UseUpdateGroupRequest),
});

export const useUpdateGroupMemberPet = createApiMutation<UseUpdateGroupMemberPetData, UseUpdateGroupMemberPetRequest>({
  mutationFn: (req) => apiClientManager.apis.group.updateGroupMemberPet(req as UseUpdateGroupMemberPetRequest),
});

export const useUpdateGroupMemberUser = createApiMutation<UseUpdateGroupMemberUserData, UseUpdateGroupMemberUserRequest>({
  mutationFn: (req) => apiClientManager.apis.group.updateGroupMemberUser(req as UseUpdateGroupMemberUserRequest),
});

export const useUpdateGroupSchedule = createApiMutation<UseUpdateGroupScheduleData, UseUpdateGroupScheduleRequest>({
  mutationFn: (req) => apiClientManager.apis.group.updateGroupSchedule(req as UseUpdateGroupScheduleRequest),
});

export type { UseBatchAssignManagerRequest, UseBatchAssignManagerData, UseBatchChangeStatusRequest, UseBatchChangeStatusData, UseToggleActivityTypeRequest, UseToggleActivityTypeData, UseUpdateActivityRequest, UseUpdateActivityData, UseUpdateActivityTypeRequest, UseUpdateActivityTypeData, UseUpdateGroupRequest, UseUpdateGroupData, UseUpdateGroupMemberPetRequest, UseUpdateGroupMemberPetData, UseUpdateGroupMemberUserRequest, UseUpdateGroupMemberUserData, UseUpdateGroupScheduleRequest, UseUpdateGroupScheduleData } from "@api/@types/group";
